import { createAction, props } from '@ngrx/store';
import { CheckinPassengerInputState } from './checkin-passenger-input.state';

/** StateDetailsActions */
const ACTION_SET = '[CheckinPassengerInput] set';
const ACTION_UPDATE = '[CheckinPassengerInput] update';
const ACTION_RESET = '[CheckinPassengerInput] reset';

/**
 * Clear the current store object and replace it with the new one
 */
export const setCheckinPassengerInput = createAction(ACTION_SET, props<CheckinPassengerInputState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateCheckinPassengerInput = createAction(ACTION_UPDATE, props<Partial<CheckinPassengerInputState>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetCheckinPassengerInput = createAction(ACTION_RESET);
